var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ItpPage",
    {
      attrs: {
        size: _vm.size,
        header: _vm.documentTitle,
        loaded: _vm.loaded,
        noShow: !_vm.loaded,
        modal: _vm.modal,
        "itp-cname": "Printers",
        modalBindings: _vm.b_7315092382398562_modalBindings
      },
      on: {
        close: function($event) {
          return _vm.evh_7315092382398562_close($event, {})
        }
      }
    },
    [
      _vm.loaded
        ? _c(
            "DIV",
            { staticClass: "overflow-auto h-100 p-3" },
            [
              _c(
                "ItpBox",
                { staticClass: "mb-3", attrs: { alignItems: "center" } },
                [
                  _c("strong", [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm._f("pgettext")(
                            "Printer configurations",
                            "Printers"
                          )
                        ) +
                        "\n      "
                    )
                  ]),
                  _vm._v(" "),
                  _c("ItpButton", {
                    staticClass: "ml-3",
                    attrs: {
                      icon: "fa-sync-alt",
                      text: _vm._f("gettext")("Reload"),
                      variant: "light",
                      size: "sm",
                      spinning: _vm.actions.reload.isRunning
                    },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        $event.stopPropagation()
                        return _vm.evh_8320016629450276_clickPreventStop(
                          $event,
                          {}
                        )
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("ItpButton", {
                    staticClass: "ml-3",
                    attrs: {
                      text: _vm._f("pgettext")("Add printer...", "Printers"),
                      variant: "light",
                      size: "sm"
                    },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        $event.stopPropagation()
                        return _vm.evh_6705964765214521_clickPreventStop(
                          $event,
                          {}
                        )
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("ItpButton", {
                    staticClass: "ml-3",
                    attrs: {
                      icon: "fa-file-invoice",
                      text: _vm._f("pgettext")("Export", "Printers"),
                      variant: "light",
                      size: "sm",
                      disabled: !_vm.items || !_vm.items.length,
                      "use-auth": "",
                      "force-download": "",
                      downloadFileName: "printer-configurations.yaml",
                      href: _vm.$fn.urlFor("export_object_by_type", {
                        object_type: _vm.objectType
                      })
                    }
                  }),
                  _vm._v(" "),
                  _c("ItpButton", {
                    staticClass: "ml-3",
                    attrs: {
                      icon: "fa-file-invoice",
                      text: _vm._f("pgettext")("Import", "Printers"),
                      variant: "light",
                      size: "sm"
                    },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        $event.stopPropagation()
                        return _vm.evh_8116269939469002_clickPreventStop(
                          $event,
                          {}
                        )
                      }
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.loaded
                ? _c("ItpDataTable", {
                    ref: "table",
                    staticClass: "h-100",
                    attrs: {
                      tableId: "Settings.Printers",
                      editable: _vm.b_3343864469950044_editable,
                      value: _vm.items,
                      globs: { open: _vm.open },
                      columns: _vm.b_3343864469950044_columns
                    }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded ? _c("template", { slot: "footer" }) : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }